import type { ToolMeta } from "../types";

export const toolMeta = {
  slug: "redirect-analyzer",
  title: "Redirect Analyzer",
  description:
    "Map URL redirect chains, trace status codes, final destinations, and HTTP-to-HTTPS upgrade behavior.",
  category: "SEO",
} satisfies ToolMeta;
